export default __webpack_public_path__ + "static/media/Version (1) - Hobbit_04.6ee7fe77.jpg";